<template>
  <button
    type="button"
    :class="{
      'bg-emerald-600': defined_condition,
      'bg-gray-200': !defined_condition,
      'h-4 w-8': size === 'sm',
      'h-6 w-11': size === 'md',
      'h-8 w-14': size === 'lg',
    }"
    class="relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-1 focus:ring-teal-500 focus:ring-offset-2"
    role="switch"
    :disabled="is_disabled"
    :aria-checked="defined_condition"
    @click="defined_condition = !defined_condition"
  >
    <span class="sr-only">{{ screenReaderText }}</span>
    <span
      aria-hidden="true"
      :class="{
        'translate-x-4': defined_condition && size === 'sm',
        'translate-x-6': defined_condition && size === 'md',
        'translate-x-8': defined_condition && size === 'lg',
        'translate-x-0': !defined_condition,
        'h-3 w-3': size === 'sm',
        'h-5 w-5': size === 'md',
        'h-7 w-7': size === 'lg',
      }"
      class="pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
    />
  </button>
</template>

<script>
export default {
  name: 'ToggleInput',

  props: {
    condition: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    screenReaderText: {
      type: String,
      default: 'Toggle',
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value),
    },
  },

  emits: ['conditionChanged'],

  data() {
    return {
      defined_condition: this.condition,
      is_disabled: this.isDisabled,
    }
  },

  watch: {
    defined_condition(newCondition) {
      this.$emit('conditionChanged', newCondition)
    },
  },
}
</script>
